import React, { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import { useApp, useService, useTheme } from "contexts";
import { Custom, Item } from "components";
import { RepoType } from "types";

type Props = {};

export const Repo = (props: Props) => {
  const { t } = useApp();
  const { theme } = useTheme();
  const { github } = useService();

  const [page, setPage] = useState<number>(1);
  const [hasMore, setHasMore] = useState<boolean>(true);
  const [repositories, setRepositories] = useState<RepoType[]>([]);

  useEffect(() => {
    fetchRepositories();
  }, [page]);

  async function fetchRepositories() {
    const count = 9;
    const response = await github.all(page, count);
    setHasMore(response.length % count === 0 && response.length > 0);
    setRepositories(response);
  }

  function loadMore() {
    setPage(page + 1);
  }

  return (
    <Box
      component="section"
      id="repo"
      sx={{ pt: { xs: theme.spacing.xl, md: theme.spacing.xxl }, pb: theme.spacing.sm, width: "100%", position: "relative" }}
    >
      {/* Section Header */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "flex-start", md: "flex-end" },
          justifyContent: "space-between",
          mb: theme.spacing.xl,
          gap: theme.spacing.sm,
        }}
      >
        <Box>
          <Box
            sx={{
              fontFamily: '"Space Mono", monospace',
              fontSize: theme.font.xxs,
              fontWeight: theme.font.bold,
              color: theme.color.primary.color,
              letterSpacing: "0.1em",
              textTransform: "uppercase",
            }}
          >
            {t.sections?.repo_badge}
          </Box>
          <Custom.Typography
            variant="h2"
            sx={{
              fontSize: { xs: theme.font.xl, md: theme.font.xxl },
              fontWeight: theme.font.extraBold,
              letterSpacing: "-0.02em",
              mt: theme.spacing.xxs,
            }}
          >
            {t.title.repo}
          </Custom.Typography>
        </Box>
        <Box
          sx={{
            fontFamily: '"Space Mono", monospace',
            fontSize: theme.font.xxs,
            color: theme.color.font.accent,
          }}
        >
          {t.sections?.repo_sync}
        </Box>
      </Box>

      {/* Repositories Grid */}
      <Grid container spacing={theme.spacing.md}>
        {repositories.map((repo: RepoType, i: number) => (
          <Grid item xs={12} sm={6} md={4} key={i}>
            <Item.Repo item={repo} />
          </Grid>
        ))}
      </Grid>

      {/* Load More Button */}
      {hasMore && (
        <Box sx={{ display: "flex", justifyContent: "center", mt: theme.spacing.xl }}>
          <Custom.Button onClick={loadMore} sx={{ px: theme.spacing.xl, py: theme.spacing.sm }}>
            {t.label.load_more}
          </Custom.Button>
        </Box>
      )}
    </Box>
  );
};